import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
const ContactPage = () => {
  return <div className="container mx-auto px-4 py-12" data-id="element-178">
      <h1 className="text-3xl font-bold mb-8 text-[#1A2B4C]" data-id="element-179">Contact Us</h1>
      <div className="bg-white rounded-lg shadow-sm p-8" data-id="element-180">
        <h2 className="text-2xl font-bold mb-6 text-[#1A2B4C]" data-id="element-181">
          Welcome to Elevatefix
        </h2>
        <div className="mb-8" data-id="element-182">
          <p className="mb-4" data-id="element-183">
            Welcome to Elevatefix, your trusted choice for fast and reliable
            appliance repairs and service plans across the UK. Our expert
            engineers specialise in servicing your essential home
            appliances—from washing machines and ovens to tumble dryers and
            fridges. We are committed to delivering high-quality repairs,
            transparent fixed pricing, and outstanding customer service.
          </p>
          <p className="mb-4" data-id="element-184">
            Whether you need an urgent repair, routine maintenance, or a
            customised service plan, Elevatefix has you covered. We understand
            how crucial your appliances are to your daily life, which is why we
            prioritise prompt responses, clear communication, and dependable
            support at every stage.
          </p>
          <p className="mb-4" data-id="element-185">
            If you have questions, need advice, or want help selecting the right
            plan, please get in touch. You can easily contact us via email or by
            calling our friendly customer support team.
          </p>
          <p className="mb-4" data-id="element-186">
            We're here to keep your home running smoothly so you can relax
            knowing your appliances are in expert hands.
          </p>
        </div>
        <h2 className="text-2xl font-bold mb-6 text-[#1A2B4C]" data-id="element-187">
          Contact Details
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-188">
          <div data-id="element-189">
            <div className="flex items-center mb-6" data-id="element-190">
              <PhoneIcon size={24} className="mr-4 text-[#1FC5A8]" data-id="element-191" />
              <div data-id="element-192">
                <h3 className="font-bold text-[#1A2B4C]" data-id="element-193">Phone</h3>
                <p data-id="element-194">0800 055 4969</p>
              </div>
            </div>
            <div className="flex items-center mb-6" data-id="element-195">
              <MailIcon size={24} className="mr-4 text-[#1FC5A8]" data-id="element-196" />
              <div data-id="element-197">
                <h3 className="font-bold text-[#1A2B4C]" data-id="element-198">Email</h3>
                <p data-id="element-199">dronakoirala6@gmail.com</p>
              </div>
            </div>
            <div className="flex items-center mb-6" data-id="element-200">
              <MapPinIcon size={24} className="mr-4 text-[#1FC5A8]" data-id="element-201" />
              <div data-id="element-202">
                <h3 className="font-bold text-[#1A2B4C]" data-id="element-203">Address</h3>
                <p data-id="element-204">1a Tower Workshops, 58 Riley Rd, London SE1 3DG</p>
              </div>
            </div>
          </div>
          <div data-id="element-205">
            <form data-id="element-206">
              <div className="mb-4" data-id="element-207">
                <label className="block text-[#1A2B4C] font-medium mb-2" htmlFor="name" data-id="element-208">
                  Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1FC5A8]" placeholder="Your name" data-id="element-209" />
              </div>
              <div className="mb-4" data-id="element-210">
                <label className="block text-[#1A2B4C] font-medium mb-2" htmlFor="email" data-id="element-211">
                  Email
                </label>
                <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1FC5A8]" placeholder="Your email" data-id="element-212" />
              </div>
              <div className="mb-4" data-id="element-213">
                <label className="block text-[#1A2B4C] font-medium mb-2" htmlFor="message" data-id="element-214">
                  Message
                </label>
                <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1FC5A8]" placeholder="Your message" data-id="element-215"></textarea>
              </div>
              <button type="submit" className="bg-[#F48C06] hover:bg-[#e07f00] text-white font-bold py-3 px-6 rounded-lg transition-colors" data-id="element-216">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>;
};
export default ContactPage;